import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [mfaRequired, setMfaRequired] = useState(false);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const { loginSuccess } = useAuth();
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await apiClient.post('/auth/login', { email, password });
      if (res.data.mfaRequired) {
        setMfaRequired(true);
        setUserId(res.data.userId);
      } else {
        loginSuccess(res.data.token, res.data.user);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  async function handleVerifyMfa(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await apiClient.post('/auth/verify-mfa', { userId, code: mfaCode });
      loginSuccess(res.data.token, res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Verification failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>Welcome back</h1>
        <p className="auth-subtitle">Log in to manage your appointments and care.</p>

        {error && <div className="alert alert-error">{error}</div>}

        {!mfaRequired ? (
          <form onSubmit={handleLogin}>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="form-field">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button className="btn btn-primary" disabled={busy}>{busy ? 'Signing in…' : 'Log in'}</button>
            <p className="auth-footer-link" style={{ textAlign: 'right', marginTop: 10 }}>
              <Link to="/forgot-password">Forgot password?</Link>
            </p>
          </form>
        ) : (
          <form onSubmit={handleVerifyMfa}>
            <div className="form-field">
              <label htmlFor="mfa">Enter the code we emailed you</label>
              <input id="mfa" required value={mfaCode} onChange={(e) => setMfaCode(e.target.value)} />
            </div>
            <button className="btn btn-primary" disabled={busy}>{busy ? 'Verifying…' : 'Verify & Log in'}</button>
          </form>
        )}

        <p className="auth-footer-link">
          Don't have an account? <Link to="/register">Register here</Link>
        </p>
      </div>
    </div>
  );
}
